import type { IconSvgObject } from './types';

const ChevronFirstIcon: IconSvgObject = [
  ["path", { d: "M17 6L11 12L17 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronFirstIcon;
